"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var nanoid_1 = require("nanoid");
var IframeObject_1 = require("./IframeObject");
var IframeWidget = function (_a) {
    var iframeProps = _a.iframeProps;
    var _b = react_1.default.useState(false), showIframe = _b[0], setIframeVisibility = _b[1];
    var _c = react_1.default.useState((0, nanoid_1.nanoid)()), iframeKey = _c[0], setIframeKey = _c[1];
    var refreshInterval = iframeProps.refreshInterval, src = iframeProps.src, styles = iframeProps.styles;
    // force rerender iframe element by changing key if refreshInterval is given.
    (0, react_1.useEffect)(function () {
        var timer;
        if (typeof refreshInterval === 'number' && refreshInterval > 0) {
            timer = setTimeout(function () {
                setIframeKey((0, nanoid_1.nanoid)());
            }, refreshInterval * 1000);
        }
        return function () {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [iframeKey, refreshInterval]);
    return (react_1.default.createElement("div", { style: {
            overflow: 'hidden',
            position: 'absolute',
            width: '100%',
            height: '100%',
            display: showIframe ? 'block' : 'none'
        } },
        react_1.default.createElement("div", { style: __assign({ width: '100%', height: '100%', position: 'absolute' }, styles) },
            react_1.default.createElement("iframe", { width: '100%', height: '100%', scrolling: 'no', key: iframeKey, style: { border: 0 }, src: src && (0, IframeObject_1.isValidUrl)(src) ? src : '', onLoad: function () { return setIframeVisibility(true); } }))));
};
exports.default = IframeWidget;
//# sourceMappingURL=IframeWidget.js.map